var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSleet = function SvgSleet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.153 11.74c.53.143.843.69.7 1.22l-1.92 7.071a.995.995 0 0 1-1.92-.521l1.92-7.072a.995.995 0 0 1 1.22-.699",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.648 12.93a.995.995 0 0 1 1.407.004l5.164 5.198a.995.995 0 1 1-1.412 1.402l-5.163-5.198a.995.995 0 0 1 .004-1.406",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.435 15.045a.995.995 0 0 1-.708 1.215l-7.083 1.872a.995.995 0 0 1-.509-1.923l7.084-1.872a.995.995 0 0 1 1.216.707",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.953 3.994c-1.241 0-2.324.334-3.283.993-.953.654-1.564 1.488-1.872 2.514a1 1 0 0 1-.757.69c-.944.19-1.667.614-2.22 1.264-.561.659-.827 1.38-.827 2.2 0 .4.066.763.187 1.092a.995.995 0 0 1-1.865.69 5.1 5.1 0 0 1-.311-1.783c0-1.307.443-2.482 1.3-3.488a5.67 5.67 0 0 1 2.778-1.787c.488-1.232 1.318-2.248 2.461-3.032 1.304-.895 2.782-1.342 4.409-1.342 1.993 0 3.732.636 5.156 1.924 1.212 1.096 1.93 2.427 2.12 3.961a5 5 0 0 1 2.357 1.36v.001c.857.88 1.313 1.947 1.313 3.16 0 .7-.15 1.366-.456 1.978a.995.995 0 1 1-1.78-.89c.16-.32.246-.677.246-1.088 0-.667-.233-1.243-.746-1.77-.512-.524-1.157-.836-1.982-.923a.995.995 0 0 1-.89-.99c0-1.303-.488-2.393-1.517-3.324-1.033-.934-2.286-1.41-3.821-1.41",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.805 14.23a.995.995 0 0 1 .68 1.231l-.284.99a.995.995 0 1 1-1.912-.55l.285-.99a.995.995 0 0 1 1.23-.68M14.948 15.22c.53.142.845.687.703 1.218l-.267.996a.995.995 0 0 1-1.921-.515l.267-.996a.995.995 0 0 1 1.218-.703M17.51 18.178a.995.995 0 0 1 .682 1.23l-.285.99a.995.995 0 1 1-1.912-.55l.285-.99a.995.995 0 0 1 1.23-.68M13.668 19.212a.995.995 0 0 1 .688 1.227l-.278.992a.995.995 0 1 1-1.916-.539l.28-.991a.995.995 0 0 1 1.226-.689",
    clipRule: "evenodd"
  })));
};
export default SvgSleet;